import { render } from "./NewRowNiche.vue?vue&type=template&id=5616c8f7"
import script from "./NewRowNiche.vue?vue&type=script&lang=js"
export * from "./NewRowNiche.vue?vue&type=script&lang=js"

import exportComponent from "/builds/linkbuilding-crm/crm-v2-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__